import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import CrmTeam from "./CrmTeam";
import CrmSources from "./CrmSources";
import CrmLostReasons from "./CrmLostReasons";
import GridConfig from "../GridConfig";
import { Header } from '../Header';
import { Footer } from '../Footer';
import { NavLink } from 'react-router-dom';
import CrmCaseStatuses from "./CrmCaseStatuses";
import CrmTeamUsers from "./CrmTeamUsers";

export default class CrmTeams extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            solutionId: props.SolutionId,
            controllerName: 'crm/team',
            data: null,
            loading: true,
            configName: 'teams_grid',
            moduleName: 'تیم ها',
            systemModuleId: 25,
            moduleAccessStatus: 1,
            menuId: 74
        };
        this.state.filters = {
            personName: '',
            mobile: '',
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    sources() {
        this.removeKeyDown();
        this.showComponents({ component: <CrmSources Caller={this} /> });
    }
    showStatus(crmTeamId) {
        this.removeKeyDown();
        this.showComponents({ component: <CrmCaseStatuses CrmTeamId={crmTeamId} Caller={this} /> });
    }
    lostReasons() {
        this.removeKeyDown();
        this.showComponents({ component: <CrmLostReasons Caller={this} /> });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <CrmTeam Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <CrmTeam Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "عنوان", show: true },
                { field: "createDateString", caption: "تاریخ ثبت", show: false },
                { field: "editDateString", caption: "تاریخ بروزرسانی", show: false }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'title' && f.show) t.push({ field: f.field, flex: 4, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.title}</a> } });

            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: 'id', filter: false, headerName: 'عملیات', cellRenderer: (props) => {
                return [
                    <a className="hand text-danger" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-trash"></em><span>حذف</span></a>
                ]
            }
        });
        return t;
    }
    showUsers(crmTeamId) {
        this.removeKeyDown();
        this.showComponents({ component: <CrmTeamUsers Caller={this} CrmTeamId={crmTeamId} /> });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        {this.hasPermission(196) && <li>
                                            <a onClick={e => this.onAdd()} className="hand btn btn-primary"><span className="shortcut">F2 - </span><span>افزودن تیم جدید</span></a>
                                        </li>}
                                        <li>
                                            <a onClick={e => this.sources()} className="hand btn btn-warning">سرنخها</a>
                                        </li>
                                        <li>
                                            <a onClick={e => this.lostReasons()} className="hand btn btn-warning">دلایل عدم نتیجه</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner position-relative card-tools-toggle">
                            <div className="card-title-group">
                                <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                    <div className="form-inline flex-nowrap gx-3">
                                        <div className="form-wrap">
                                            <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="نام تیم" className="form-control" />
                                        </div>
                                        <div className="form-wrap">
                                            <input type="text" defaultValue={this.state.filters.personName} onChange={e => this.state.filters.personName = e.target.value} placeholder="نام شخص" className="form-control" />
                                        </div>
                                        <div className="form-wrap">
                                            <input type="text" defaultValue={this.state.filters.mobile} onChange={e => this.state.filters.mobile = e.target.value} placeholder="شماره موبایل" className="form-control" />
                                        </div>
                                        <div className="btn-wrap">
                                            <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button></span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    {this.isEmpty(this.state.data.records) ?
                        <div className="card card-bordered card-stretch">
                            <div className="card-inner-group">
                                <div className="example-alert">
                                    <div className="alert alert-pro alert-warning">
                                        <div className="alert-text">
                                            <h6>توجه</h6>
                                            <p>شما در حال حاضر هیچ تیمی ای ایجاد نکرده اید</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="row g-gs">
                            {this.state.data.records.map((record, index) =>
                                <div className="col-sm-4 col-lg-4 col-xxl-3">
                                    <div className="card card-bordered h-100">
                                        <div className="card-inner">
                                            <div className="project">
                                                <div className="project-head">
                                                    <a onClick={e => this.onEdit(record.id)} className="hand project-title">
                                                        <div className="project-info">
                                                            <h6 className="title"><em className="icon ni ni-pen"></em> {record.title}</h6>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div className="project-meta">
                                                    <a onClick={e => this.confirmRemove(record.id)} className="hand  text-danger">
                                                        <span className="nk-menu-text"><em className="icon ni ni-trash"></em> حذف</span>
                                                    </a>
                                                    <a onClick={e => this.showStatus(record.id)} className="hand text-warning">
                                                        <span className="nk-menu-text"><em className="icon ni ni-list"></em> وضعیتها</span>
                                                    </a>
                                                    <a onClick={e => this.showUsers(record.id)} className="hand">
                                                        <span className="nk-menu-text"><em className="icon ni ni-list"></em> اعضا</span>
                                                    </a>
                                                    <NavLink to={"/crm/cases/" + record.id + "/"} className="hand text-success">
                                                        <span className="nk-menu-text"><em className="icon ni ni-list"></em> بورد</span>
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    }
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}